import { GridReducer } from '../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../common/grid/filter/grid-filter.reducer';
import * as GRID from '../../../common/grid/grid.constants';
import * as FORM from '../../../common/form/input/input.constants';
import { TYPES as ACC_TYPES } from '../accreditation-action-type.constants';
import { TYPES } from './settings-action-type.constants';
import { IDS } from './settings-action-id.constants';
import merge from 'lodash/merge';
import get from 'lodash/get';
import set from 'lodash/set';
import {getDocFileNameFromPath} from "../../../common/utils/util.path";

/**
 * @function SettingsReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function SettingsReducer(state, action) {

    if (typeof state === 'undefined') {
        return {
            autocompleteSections: [],
            frameworkDetails: {},
            leadingZerosOptions: [
                {value: '1', label: '1'},
                {value: '2', label: '2'},
                {value: '3', label: '3'},
                {value: '9', label: 'a'},
                {value: '8', label: 'A'},
            ],
            leadingZerosOptions3rdLevel: [
                {value: '1', label: '1'},
                {value: '2', label: '2'},
                {value: '3', label: '3'},
                {value: '9', label: 'a'},
                {value: '8', label: 'A'},
                {value: '0', label: 'Disabled'},
            ],
            headOffices: {
                selectedHeadOfficeUuid: null,
                notEnabledHeadOffices: [],
            },
            headOfficesGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    schemeId: null
                }
            },
            selectedHeadOfficeName: null,
            siteLocations: {
                headOfficeName: null,
            },
            siteLocationsGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    schemeId: null
                }
            },
            requirementDetails: {
                id:         null,
                level:      null,
                nodeName:   null,
                prefix:     null, //number
                siblings:   null, //node.children.map(item => parseInt(item.numberRaw.split('.').pop())),
                numberInputSelect: [],
                modulePrefixInputSelect: [],
            },
            [IDS.requirementsImportsGrid]: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path: IDS.requirementsImportsGrid,
                    scheme_code: null,
                }
            },
            selectCascadeSections: {
                level1Requirements: [],
                level2Requirements: [],
                level3Requirements: [],
                level1RequirementId: null,
                level2RequirementId: null,
                level3RequirementId: null,
            },
            evidence: {
                enabledHeadOffices: [],
                enabledSiteLocations: [],
                selectedHeadOfficeUuid: null
            },
            evidenceGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path:           IDS.evidenceGrid,
                    loc_uuid:       null,
                    requirement_id: null,
                }
            },
            evidenceDetails: {
                name: null,
                description: null,
                type_code: 'gdo', // in page add document, first item in drop down menu for document type is Generic Doc
                generator_type: 'disabled',
                sample_doc_uri: null,
                sampleDocFilename: null,
                selectCascadeSections: {
                    level1Requirements: [],
                    level2Requirements: [],
                    level3Requirements: [],
                    level1RequirementId: null,
                    level2RequirementId: null,
                    level3RequirementId: null,
                },
            },
            [IDS.evidenceApplicableHeadOfficesGrid]: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path: IDS.evidenceApplicableHeadOfficesGrid,
                    evg_id: null,
                    limit: 100,
                    offset: 0,
                }
            },
            [IDS.evidenceApplicableSitesGrid]: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path: IDS.evidenceApplicableSitesGrid,
                    evg_id: null,
                    hof_uuid: null,
                }
            },
            evidenceRequirementsGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path: IDS.evidenceRequirementsGrid,
                    ard_id: null,
                }
            },
            evidenceImportsGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path: IDS.evidenceImportsGrid,
                    scheme_code: null,
                    loc_uuid: null,
                }
            },
            sloRequiredDocs: {
                enabledHeadOffices: [],
                enabledSiteLocations: [],
                selectedSiteLocationUuid: null
            },
            sloRequiredDocsGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path:           IDS.sloRequiredDocsGrid,
                    loc_uuid:       null,
                    requirement_id: null,
                }
            },
            sloRequiredDocDetails: {
                type_code: 'gdo', // in page add document, first item in drop down menu for document type is Generic Doc
                sample_doc_uri: null,
                sampleDocFilename: null,
                selectCascadeSections: {
                    level1Requirements: [],
                    level2Requirements: [],
                    level3Requirements: [],
                    level1RequirementId: null,
                    level2RequirementId: null,
                    level3RequirementId: null,
                },
            },
            sloRequiredDocSectionsGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path: IDS.sloRequiredDocSectionsGrid,
                    ard_id: null,
                }
            },
            sloRequiredDocsImportsGrid: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    path: IDS.sloRequiredDocsImportsGrid,
                    scheme_code: null,
                    loc_uuid: null,
                }
            },
            // documentTypes: [
            //     { value: 'gdo', label: 'Generic Doc.' },
            //     { value: 'pol', label: 'Policy' },
            //     { value: 'pro', label: 'Procedure' },
            //     { value: 'coa', label: 'Contracts/Agreements' },
            //     { value: 'for', label: 'Form' },
            //     { value: 'che', label: 'Checklist' },
            // ],
            documentGeneratorTypes: [],
            submissionOrgLevels: [
                { value: 'slo', label: 'Uploaded Per Each Site' },
                { value: 'hof', label: 'Uploaded Once Per Head Office' },
            ]
        };
    }

    switch (action.type) {
        case TYPES.FETCH_GENERATOR_TYPES:
            if (action.id === IDS.accSettings) {
                return set({...state}, 'documentGeneratorTypes', action.data);
            }
            return state;
        case TYPES.SCHEME_DETAILS_REFRESH:
            if (action.id === IDS.accreditationSettingsFrameworkDetails) {
                return merge({...state}, {
                    frameworkDetails: {
                        ...action.data,
                        title: action.data.name,
                    },
                    headOfficesGrid: {
                        filter: { schemeId: action.data.id }
                    },
                    siteLocationsGrid: {
                        filter: { schemeId: action.data.id }
                    },
                })
            }
        case TYPES.SCHEME_STATUS_REFRESH:
            if (action.id === IDS.accreditationSettingsFrameworkDetails) {
                return merge({...state}, { frameworkDetails: action.data })
            }
        case TYPES.REQUIREMENT_DETAILS_REFRESH:
            if (action.id === IDS.accreditationSettingsRequirementDetails) {
                state = {...state, requirementDetails: action.data};
                return set(state, 'assessmentGrid.filter.requirement_id', action.data.id);
            }

        case TYPES.SELECT_CASCADE_SECTIONS:
            if (action.id.split('.')[0] === IDS.accSettings) {
                let component = action.id.split('.')[1];
                component = component ? `${component}.` : '';
                state = {...state};
                if(action.schemeCode)
                    set(state,'requirementDetails.schemeCode', action.schemeCode);
                if (action.level < 3) {
                    set(state,
                        `${component}selectCascadeSections.level${action.level + 1}Requirements`,
                        action.sections.length === 0 ? [{value:0, label:''}] : action.sections.map(item => ({
                            value: item.id,
                            label: item.name,
                        }))
                    )
                }
                if (action.level === 1) {
                    set(state,
                        `${component}selectCascadeSections.level3Requirements`,
                        action.level3Requirements.length === 0 ? [{value:0, label:''}] : action.level3Requirements.map(item => ({
                            value: item.id,
                            label: item.name,
                        }))
                    )
                }
                // remove reset value -1 which is avoiding drop down menu automatically pick first item
                if(state.selectCascadeSections.level1RequirementId === -1)
                    state = set(state, `${component}selectCascadeSections.level1RequirementId`, null);
                if(state.selectCascadeSections.level2RequirementId === -1)
                    state = set(state, `${component}selectCascadeSections.level2RequirementId`, null);
                if(state.selectCascadeSections.level3RequirementId === -1)
                    state = set(state, `${component}selectCascadeSections.level3RequirementId`, null);

                return set(state, `${component}selectCascadeSections.level${action.level}RequirementId`, action.sectionId);
            }
        case TYPES.SELECT_CASCADE_SECTIONS_RESET:
            if (action.id.split('.')[0] === IDS.accSettings) {
                let component = action.id.split('.')[1];
                component = component ? `${component}.` : '';
                state = set({...state}, 'requirementDetails', null);
                return set(state, `${component}selectCascadeSections`, {
                    ...get(state, `${component}selectCascadeSections`),
                    level1RequirementId: -1,
                    level2RequirementId: -1,
                    level3RequirementId: -1,
                })
            }
        case TYPES.HOF_DOC_DETAILS_REFRESH:
            return {
                ...state,
                evidenceDetailsEmpty: state.evidenceDetailsEmpty || {...state.evidenceDetails},
                evidenceDetails: action.data
            };
        case TYPES.HOF_DOC_DETAILS_RESET:
            return {
                ...state,
                evidenceDetails: { ...state.evidenceDetailsEmpty }
            };
        case TYPES.SLO_DOC_DETAILS_REFRESH:
            return {
                ...state,
                sloRequiredDocDetailsEmpty: state.sloRequiredDocDetailsEmpty || {...state.sloRequiredDocDetails},
                sloRequiredDocDetails: action.data
            };
        case TYPES.SLO_DOC_DETAILS_RESET:
            return {
                ...state,
                sloRequiredDocDetails: state.sloRequiredDocDetailsEmpty ? { ...state.sloRequiredDocDetailsEmpty } : get(state, 'sloRequiredDocDetails'),
            };
        case TYPES.DOCUMENT_SAMPLE_DOC_CHANGED:
            if (action.id === IDS.accSettings) {
                state = set({...state}, `${action.path}.sampleDocFilename`, getDocFileNameFromPath(action.sample_doc_uri));
                return set(state, `${action.path}.sample_doc_uri`, action.sample_doc_uri);
            }
        case TYPES.FETCH_ASS_HOF_SCHEME_HEAD_OFFICES:
            if (action.id === IDS.accreditationSettingsAssessmentHeadOffice) {
                state = {...state};
                if(action.items.length) {
                    set(state, 'assessmentHeadOffice.headOffice',       action.items[0].value);
                    set(state, 'assessmentHeadOffice.headOfficeName',   action.items[0].label);
                }
                return set(state, 'assessmentHeadOffice.headOffices',   action.items)
            }
        case TYPES.ASS_HOF_SELECT_HEAD_OFFICE:
            if (action.id === IDS.accreditationSettingsAssessmentHeadOffice) {
                state = set({...state}, 'assessmentHeadOffice.headOfficeName', action.headOfficeName);
                return set(state, 'assessmentHeadOffice.headOffice', action.headOffice)
            }
        case TYPES.FETCH_NOT_ENABLED_HEAD_OFFICES:
            if (action.id === IDS.accreditationSettingsHeadOffices) {
                return set({...state}, 'headOffices.notEnabledHeadOffices', action.items)
            }
        case TYPES.SELECTED_HEAD_OFFICE_RESET:
            if (action.id === IDS.accreditationSettingsHeadOffices) {
                return set({...state}, 'headOffices.selectedHeadOfficeUuid', null)
            }
        case TYPES.SET_SITE_LOCATIONS_HEADER:
            if (action.id === IDS.accSettings) {
                return set({...state}, 'siteLocations', action.data)
            }
        case ACC_TYPES.FETCH_SCHEME_ENABLED_HEAD_OFFICES:
            state = set({...state}, 'frameworkDetails.id', action.schemeId || state.frameworkDetails.id);
            return set(state, `${action.id}.enabledHeadOffices`, action.items)
        case ACC_TYPES.FETCH_SCHEME_ENABLED_SITE_LOCATIONS:
            state = {...state};
            let firstSiteLocation = action.items[0]?.value;
            set( state, `sloRequiredDocsGrid`,
                GridReducer(get(state, `sloRequiredDocsGrid`),{
                    type:GRID.GRID_FILTER,
                    filter: {
                        loc_uuid: firstSiteLocation || action.headOfficeUuid
                    }
                })
            )
            return set(state, `sloRequiredDocs.enabledSiteLocations`, action.items)
        case TYPES.SLO_DOCS_LOCATION_SELECTS_RESET:
            if (action.id === IDS.sloRequiredDocs) {
                state = set({...state}, 'sloRequiredDocs.slo_uuid', null)
                set(state, 'sloRequiredDocs.enabledSiteLocations', []);
                return set(state, 'sloRequiredDocs.hof_uuid', null)
            }
            return state;
        case TYPES.UPDATE_SELECTED_HEAD_OFFICE_NAME:
            if (action.id === IDS.accSettings) {
                return set({...state}, 'selectedHeadOfficeName', action.selectedHeadOfficeName)
            }
            return state;
        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if(action.id === IDS.accSettings) {
                return set({...state}, action.path, GridReducer(get(state, action.path), action));
            }
        case FORM.INPUT_SELECT:
            if (action.id.split('.')[0] === IDS.accSettings) {
                const propertyName = action.path.split('.').pop();
                const component = action.id.split('.')[1] || action.path.split('.')[0];
                switch(component) {
                    case IDS.evidenceGrid:
                        state = set ({...state}, 'evidenceDetails.headOfficeName', action.item?.label);
                        set(state, 'evidenceGrid',
                            GridReducer(get(state, 'evidenceGrid'), {
                                type: GRID.GRID_FILTER,
                                filter: {
                                    [propertyName]: action.input
                                }
                            })
                        )
                        return state;
                    case IDS.sloRequiredDocsGrid:
                        state = set ({...state}, `sloRequiredDocDetails.headOfficeName`, action.item?.label);
                        set(state, 'sloRequiredDocsGrid',
                            GridReducer(get(state, 'sloRequiredDocsGrid'), {
                                type: GRID.GRID_FILTER,
                                filter: {
                                    [propertyName]: action.input,
                                }
                            })
                        )
                        return state;
                    case IDS.evidenceImportsGrid:
                        state = {...state};
                        set(state, 'evidenceImportsGrid',
                            GridReducer(get(state, 'evidenceImportsGrid'), {
                                type: GRID.GRID_FILTER,
                                filter: {
                                    [propertyName]: action.input,
                                }
                            })
                        )
                    case 'frameworkDetails':
                    case 'requirementDetails':
                        return set(state, action.path, action.input);
                }
            }
        case FORM.INPUT_TEXT:
        case FORM.INPUT_TEXT_AREA:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
            if (action.id === IDS.accSettings) {
                state = {...state};
                const component = action.path.split('.')[0];
                if(['sloRequiredDocsGrid','evidenceGrid'].includes(component)) {
                    const propertyName = action.path.split('.').pop();
                    set(state, component,
                        GridReducer(get(state, component), {
                            type: GRID.GRID_FILTER,
                            filter: {
                                [propertyName]: action.input,
                            }
                        })
                    )
                }
                else
                    return set(state, action.path, action.input)
            }
        case 'LOCATION_SELECTED': // slo select-cascade.js
            if (action.id === IDS.accreditationSettingsHeadOffices) {
                return set({...state}, 'headOffices.selectedHeadOfficeUuid', action.uuid)
            }
            // if(action.id === IDS.accreditationSettingsAssessmentGrid && action.type_code === 'slo') {
            //     state = set({...state},  `${IDS.assessmentGrid}.selectedLocationUuid`, action.uuid);
            //     if(get(state, `${IDS.assessmentGrid}.filterOpened`))
            //         state = set(state, `${IDS.assessmentGrid}.filter.slo_uuid`, action.uuid);
            //     return set( state, IDS.assessmentGrid, GridReducer(get(state, IDS.assessmentGrid),{ type:GRID.GRID_RELOAD }))
            // }
        default:
            return state;
        }
}
